// Google Maps cloud-based Map ID (correct GCP project, style hides lodging POIs)
export const GOOGLE_MAPS_MAP_ID = '90dce60a2cbc64eafbe39ac8';
